import React, { useState, useEffect } from "react";
import "./HouseList.scss";

//icons import
import { CiEdit } from "react-icons/ci";
import { LiaSaveSolid } from "react-icons/lia";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";

//functions for datat fetching
import { addHouse, getAllHouses } from "../../../../redux/slices/sliceActions";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

const HouseListTable = ({
  mockHouses,
  setHouseInformation,
  setShowModal,
  propertyId,
  toastSuccess,
  toastError,
}) => {
  // redux methods
  const dispatch = useDispatch();

  const houseTypeChoices = [
    "Single Room",
    "Studio",
    "Bed Sitter",
    "One Bedroom",
    "Two Bedroom",
    "Three Bedroom",
    "Office",
    "Shop",
  ];

  const [houseData, setHouseData] = useState(
    mockHouses.map((house) => ({
      houseNumber: (house.house_no ?? "").toUpperCase(),
      houseType: house.type ?? houseTypeChoices[0],
      rent: house.rent ?? "",
      meterNumber: house.meter_no ?? "",
      initialWaterMeterReading: house.initial_meter_reading ?? "",
      occupationStatus: house.status === "vacant" ? 0 : 1,
      isNewRow: house.isNewRow ?? false,
      house_id: house._id,
    }))
  );

  useEffect(() => {
    setHouseData(
      mockHouses.map((house) => ({
        houseNumber: (house.house_no ?? "").toUpperCase(),
        houseType: house.type ?? houseTypeChoices[0],
        rent: house.rent ?? "",
        meterNumber: house.meter_no ?? "",
        initialWaterMeterReading: house.initial_meter_reading ?? "",
        occupationStatus: house.status === "vacant" ? 0 : 1,
        isNewRow: house.isNewRow ?? false,
        house_id: house._id,
      }))
    );
  }, [mockHouses]);

  const handleSaveRow = (index) => {
    const row = houseData[index];
    if (
      !row.houseNumber ||
      !row.rent ||
      !row.meterNumber ||
      !row.initialWaterMeterReading
    ) {
      toastError("Please fill all fields");
      return;
    }

    const houseTypeMap = {
      "Single Room": "single",
      "Bed Sitter": "bed-sitter",
      Studio: "studio",
      "One Bedroom": "one-bedroom",
      "Two Bedroom": "two-bedroom",
      "Three Bedroom": "three-bedroom",
      Shop: "shop",
      Office: "office",
    };

    const mappedHouseType = houseTypeMap[row.houseType] || row.houseType;

    dispatch(
      addHouse({
        house: {
          type: mappedHouseType,
          house_no: row.houseNumber,
          rent: row.rent,
          meter_no: row.meterNumber,
          initial_meter_reading: row.initialWaterMeterReading,
        },
        propertyId: propertyId,
      })
    ).then((response) => {
      console.log("create house response", response);
      if (response?.payload?.status === "success") {
        toastSuccess("House added successfully");
      }
      dispatch(getAllHouses({ id: propertyId }));
    });
  };

  const handleSaveAll = async () => {
    const newRows = houseData.filter((house) => house.isNewRow);

    if (newRows.length === 0) {
      toastError("No new rows to save");
      return;
    }

    // Validate all new rows
    const invalidRows = newRows.filter(
      (row) =>
        !row.houseNumber ||
        !row.rent ||
        !row.meterNumber ||
        !row.initialWaterMeterReading
    );

    if (invalidRows.length > 0) {
      toastError("Please fill all fields in all new rows");
      return;
    }

    const houseTypeMap = {
      "Single Room": "single",
      "Bed Sitter": "bed-sitter",
      Studio: "studio",
      "One Bedroom": "one-bedroom",
      "Two Bedroom": "two-bedroom",
      "Three Bedroom": "three-bedroom",
      Shop: "shop",
      Office: "office",
    };

    try {
      let successCount = 0;
      let errorCount = 0;

      // Save all new rows
      for (const row of newRows) {
        const mappedHouseType = houseTypeMap[row.houseType] || row.houseType;

        const response = await dispatch(
          addHouse({
            house: {
              type: mappedHouseType,
              house_no: row.houseNumber,
              rent: row.rent,
              meter_no: row.meterNumber,
              initial_meter_reading: row.initialWaterMeterReading,
            },
            propertyId: propertyId,
          })
        );

        if (response?.payload?.status === "success") {
          successCount++;
        } else {
          errorCount++;
        }
      }

      if (successCount > 0) {
        toastSuccess(`${successCount} house(s) added successfully`);
        dispatch(getAllHouses({ id: propertyId }));
      }

      if (errorCount > 0) {
        toastError(`${errorCount} house(s) failed to save`);
      }
    } catch (error) {
      console.error("Error saving houses:", error);
      toastError("Error saving houses");
    }
  };

  const reverseHouseTypeMap = {
    single: "Single Room",
    "bed-sitter": "Bed Sitter",
    "one-bedroom": "One Bedroom",
    studio: "Studio",
    "two-bedroom": "Two Bedroom",
    "three-bedroom": "Three Bedroom",
    shop: "Shop",
    office: "Office",
  };
  return (
    <div className="house-list-table-container-pc">
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: "start" }}>House Number</th>
            <th>House Type</th>
            <th>Rent</th>
            <th>Occupation Status</th>
            <th>Electricity Meter no</th>
            <th>Initial Water Reading</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {houseData.map((house, index) => {
            if (house.isNewRow) {
              return (
                <tr key={house.house_id || index}>
                  <td className="input">
                    <input
                      type="text"
                      placeholder="House No"
                      value={houseData[index].houseNumber}
                      onChange={(e) => {
                        const updated = [...houseData];
                        updated[index].houseNumber = e.target.value.toUpperCase();
                        setHouseData(updated);
                      }}
                    />
                  </td>
                  <td className="input">
                    <div className="drop-down">
                      <DropdownSelect
                        choices={houseTypeChoices}
                        defaultChoice={houseData[index].houseType}
                        onSelect={(choice) => {
                          const updated = [...houseData];
                          updated[index].houseType = choice;
                          setHouseData(updated);
                        }}
                      />
                    </div>
                  </td>
                  <td className="input">
                    <input
                      type="number"
                      placeholder="Rent"
                      value={houseData[index].rent}
                      onChange={(e) => {
                        const updated = [...houseData];
                        updated[index].rent = e.target.value;
                        setHouseData(updated);
                      }}
                    />
                  </td>
                  <td className="dashboard-status">
                    <div
                      className="status-wrapper"
                      style={{
                        backgroundColor:
                          houseData[index].occupationStatus === 0
                            ? "#B39359"
                            : "#192A3A",
                      }}
                    >
                      {houseData[index].occupationStatus === 0
                        ? "Vacant"
                        : "Occupied"}
                    </div>
                  </td>
                  <td className="input">
                    <input
                      type="text"
                      placeholder="Meter No"
                      value={houseData[index].meterNumber}
                      onChange={(e) => {
                        const updated = [...houseData];
                        updated[index].meterNumber = e.target.value;
                        setHouseData(updated);
                      }}
                    />
                  </td>
                  <td className="input">
                    <input
                      type="number"
                      placeholder="Initial Reading"
                      value={houseData[index].initialWaterMeterReading}
                      onChange={(e) => {
                        const updated = [...houseData];
                        updated[index].initialWaterMeterReading =
                          e.target.value;
                        setHouseData(updated);
                      }}
                    />
                  </td>
                  <td>
                    <div className="action-icons">
                      <div
                        className="icon"
                        onClick={() => handleSaveRow(index)}
                      >
                        <LiaSaveSolid fontSize={20} />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
            return (
              <React.Fragment key={house.house_id || index}>
                <tr className="clickable-row">
                  <td>{house.houseNumber}</td>
                  <td>
                    {reverseHouseTypeMap[house.houseType] || house.houseType}
                  </td>

                  <td>{house.rent}</td>
                  <td className="dashboard-status">
                    <div
                      className="status-wrapper"
                      style={{
                        backgroundColor:
                          house.occupationStatus === 0 ? "#B39359" : "#192A3A",
                      }}
                    >
                      {house.occupationStatus === 0 ? "Vacant" : "Occupied"}
                    </div>
                  </td>
                  <td>{house.meterNumber}</td>
                  <td>{house.initialWaterMeterReading}</td>
                  <td
                    onClick={() => {
                      setHouseInformation(house);
                      setShowModal(true);
                    }}
                  >
                    <div className="action-icons">
                      <div className="icon">
                        <CiEdit fontSize={20} />
                      </div>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>

      {/* Save All Button */}
      {houseData.some((house) => house.isNewRow) && (
        <div
          className="save-all-container"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: "20px",
            paddingRight: "10px",
          }}
        >
          <button
            className="save-all-button"
            onClick={handleSaveAll}
            style={{
              backgroundColor: "#192A3A",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "12px 24px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0f1a24";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#192A3A";
              e.target.style.transform = "translateY(0)";
            }}
          >
            <LiaSaveSolid fontSize={18} />
            Save All New Rows
          </button>
        </div>
      )}
    </div>
  );
};

export default HouseListTable;
